import React from "react";
import { Typography as AntTypography } from "antd";
import { TypographyProps as AntTypographyProps } from "antd/lib/typography";
import "./Title.scss";

export const Title: AntTypographyProps["Title"] = (props) => {
  const { children, ...rest } = props;
  return <AntTypography.Title {...rest}>{children}</AntTypography.Title>;
};
